// @flow
export { default, Wrapper as AsInputWrapper } from './AsInput';
export type { Props } from './AsInput';



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/AsInput/index.js